export default __webpack_public_path__ + "static/media/541.ecf2434f.png";